import React, { useState } from 'react';
import './ReservationComp.css';

function ReservationComp() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    date: '',
    time: '',
    guests: 1,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.date) newErrors.date = 'Date is required';
    if (!formData.time) newErrors.time = 'Time is required';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length === 0) {
      // Submit the form (e.g., send data to an API)
      alert('Reservation submitted successfully!');
      // Clear form after submission
      setFormData({ name: '', email: '', date: '', time: '', guests: 1 });
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className="reservation-container">
      <h1>Make a Reservation</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name:</label>
          <input 
            type="text" 
            name="name" 
            value={formData.name} 
            onChange={handleChange} 
            required 
          />
          {errors.name && <span className="error">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label>Email:</label>
          <input 
            type="email" 
            name="email" 
            value={formData.email} 
            onChange={handleChange} 
            required 
          />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>

        <div className="form-group">
          <label>Date:</label>
          <input 
            type="date" 
            name="date" 
            value={formData.date} 
            onChange={handleChange} 
            required 
          />
          {errors.date && <span className="error">{errors.date}</span>}
        </div>

        <div className="form-group">
          <label>Time:</label>
          <input 
            type="time" 
            name="time" 
            value={formData.time} 
            onChange={handleChange} 
            required 
          />
          {errors.time && <span className="error">{errors.time}</span>}
        </div>

        <div className="form-group">
          <label>Number of Guests:</label>
          <input 
            type="number" 
            name="guests" 
            value={formData.guests} 
            onChange={handleChange} 
            min="1" 
            required 
          />
        </div>

        <button type="submit">Submit Reservation</button>
      </form>
    </div>
  );
}

export default ReservationComp;
